import React, { useEffect, useState } from "react";
import { Box, Paper } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import Editor from "@monaco-editor/react";
import UploadSchema from "./UploadSchema";

interface JsonEditorProps {
  value: string;
  onChange: (value: string) => void;
  onValidityChange?: (isValid: boolean) => void;
  setParseError?: (parseError: string | null) => void;
  onApiResponse?: (responseData: any) => void;
}

const dummyJsonHint = `{
  "name": "John Doe",
  "age": 30,
  "email": "john@example.com"
}`;

const JsonEditor: React.FC<JsonEditorProps> = ({ value, onChange, onValidityChange,setParseError, onApiResponse }) => {
  const [error, setError] = useState<string | null>(null);

  const handleEditorChange = (val: string | undefined) => {
    const updatedValue = val ?? "";
    onChange(updatedValue);

    try {
      JSON.parse(updatedValue);
      setError(null);
      if(!!setParseError) setParseError(null);
    } catch (err: any) {
      const match = err.message.match(/position (\d+)/);
      let lineInfo = "";
      if (match) {
        const pos = parseInt(match[1], 10);
        const lines = updatedValue.substring(0, pos).split("\n");
        lineInfo = ` at line ${lines.length}`;
      }
      if(!!onValidityChange) onValidityChange(true);
      setError(`Invalid JSON${lineInfo}: ${err.message}`);
      if(!!setParseError) setParseError(`Invalid JSON${lineInfo}: ${err.message}`);
    }
  };

  return (
    <Box>
      <div className="max-w-md mt-8">
        <Box sx={{flex : 1}}>
          <UploadSchema onApiResponse={onApiResponse}/>
        </Box>
      </div>
      <Paper variant="outlined" sx={{ height: "400px", mb: 1 }}>
        <Editor
          height="100%"
          language="json"
          defaultValue={dummyJsonHint}
          value={value}
          onChange={handleEditorChange}
          options={{
            fontSize: 14,
            minimap: { enabled: false },
            formatOnPaste: true,
            formatOnType: true,
            lineNumbers: "on",
            automaticLayout: true,
          }}
        />
      </Paper>
      {error && (
        <div className="flex items-center gap-2 mt-4 p-3 bg-red-50 text-red-700 rounded-md">
          <WarningIcon className="h-5 w-5" />
          <span>{error}</span>
        </div>
      )}
    </Box>
  );
};

export default JsonEditor;

